import { isDebugFlagEnabled } from '../../../utils/debugTools';

const isNaturalCaptureAuditDebugEnabled = () => {
  return isDebugFlagEnabled(['debugImportParser', 'debugNaturalCaptureAudit']);
};

export const emitNaturalCaptureDecisionAudit = (debugLabel = '', rows = [], categoryComparisons = []) => {
  if (!isNaturalCaptureAuditDebugEnabled()) {
    return;
  }

  const auditRows = (Array.isArray(rows) ? rows : []).map((row, index) => {
    const decision = categoryComparisons[index] || {};
    return {
      index,
      originalCategory: decision.originalCategory || row?.parsedSourceCategory || row?.category || null,
      proposedCategory: decision.proposedCategory || null,
      finalCategory: decision.finalCategory || row?.category || null,
      promotionApplied: Boolean(decision.promotionApplied),
      promotionReason: decision.promotionReason || '',
      adapterMode: decision.inputMode || row?.inputMode || '',
      detectedShape: decision.shapeHint || '',
      fallbackReason: decision.reason?.[0] || '',
    };
  });

  // eslint-disable-next-line no-console
  console.debug(`[NaturalCaptureAudit] ${debugLabel}`, auditRows);
};

export const applyNaturalCaptureCategoryDecisions = (rows = [], categoryComparisons = []) => (
  Array.isArray(rows)
    ? rows.map((row, index) => {
        const decision = categoryComparisons[index] || null;
        if (!decision || !row || typeof row !== 'object') {
          return row;
        }

        const currentCategory = String(
          row?.category
          || decision?.originalCategory
          || decision?.currentPathCategory
          || ''
        ).trim() || null;
        const finalCategory = String(
          decision?.finalCategory
          || currentCategory
          || ''
        ).trim() || null;

        const categoryDecision = {
          ...decision,
          originalCategory: decision?.originalCategory || currentCategory,
          currentPathCategory: decision?.currentPathCategory || currentCategory,
          finalCategory,
          promotionApplied: Boolean(decision?.promotionApplied && finalCategory && finalCategory !== currentCategory),
          promotionReason: decision?.promotionReason || 'no_safe_promotion_rule',
        };

        return {
          ...row,
          category: finalCategory || currentCategory || row.category || null,
          parsedSourceCategory: row?.parsedSourceCategory || currentCategory || null,
          metadata: {
            ...(row.metadata || {}),
            categoryDecision,
          },
        };
      })
    : []
);
